import React, { useEffect, useState } from "react";

import { VbzModal } from "@smiles/voebiz-ui-kit";
import { useFlags } from "launchdarkly-react-client-sdk";

import { getModalContent } from "../../../../services/services";

const Modal = ({ isOpen, toggle }: { isOpen?: boolean; toggle: () => void }) => {
  const [modalContent, setModalContent] = useState<string>();

  const { apiDomain, liferaySiteId } = useFlags();

  const toggleOptions = () => toggle();

  const handleMoreDetails = () => {
    window.location.href = "https://voebiz.smiles.com.br/novovoebiz";
  };

  const ModalFooter = () => {
    return (
      <div className="history-news__modal__footer">
        <button onClick={handleMoreDetails} type="button" className="history-news__modal__footer__btn--action">
          Confira mais detalhes
        </button>
        <button onClick={toggleOptions} type="button" className="history-news__modal__footer__btn--back">
          Voltar
        </button>
      </div>
    );
  };

  useEffect(() => {
    getModalContent(window.location.origin, liferaySiteId).then((res) => {
      setModalContent(res);
    });
  }, [apiDomain, liferaySiteId]);

  return (
    <VbzModal isOpen={isOpen} type="right" desktopSize="small" toggle={toggle} className="history-news__modal">
      {modalContent && (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: modalContent }}
        />
      )}
      <ModalFooter />
    </VbzModal>
  );
};

Modal.defaultProps = { isOpen: false };

export default Modal;
